import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { mascot_img_main } from '../../imagepath';
import { loginicon01 } from '../../imagepath';
import { loginicon02 } from '../../imagepath';
import { loginicon03 } from '../../imagepath';
import useAuth from '../../../hooks/useAuth';
import ResetPasswordForEmail from './ResetPassword/ResetPasswordForEmail';
import ResetPassword from './ResetPassword/ResetPassword';
import { Spin } from 'antd';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const { loading, status, handleResetPassword, handleForgotPasswordSubmit } =
      useAuth();
  
    const handleEmailSubmit = (data) => {
      if (data?.email) {
        handleResetPassword(data?.email);
      }
    };
    const handlePasswordSubmit = async (data) => {
      try {
        if (data?.code && data?.password && data?.confirmPassword) {
          await handleForgotPasswordSubmit(data);
        }
        navigate('/');
      } catch (error) {
          console.log('error', error);
      }
    };
  return (
    <div>
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            {/* Login logo */}
            <div className="col-lg-6 login-wrap">
              <div className="login-sec-centered">
                <div className="log-img">
                  <img className="img-fluid" src={mascot_img_main} alt="Logo" />
                </div>
              </div>
            </div>
            {/* /Login logo */}
            {/* Login Content */}
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      {/* <div className="account-logo">
                        <Link to="/admin-dashboard">
                          <img
                            src={logoVoxel}
                            alt="#"
                            style={{ height: 100, width: 400 }}
                          />
                        </Link>
                      </div> */}
                      <h2>Reset Password</h2>
                      <Spin spinning={loading}>
                        {/* Form */}
                        {status === 'email' ? (
                          <ResetPasswordForEmail
                            loading={loading}
                            onSubmit={handleEmailSubmit}
                          />
                        ) : null}
                        {status === 'code' ? (
                          <ResetPassword
                            loading={loading}
                            onSubmit={handlePasswordSubmit}
                          />
                        ) : null}
                        {/* /Form */}
                        <div className="next-sign">
                          <p className="account-subtitle">
                            Need an account?
                            <Link to="/"> Login</Link>
                          </p>
                          {/* Social Login */}
                          <div className="social-login">
                            <Link to="#">
                              <img src={loginicon01} alt="#" />
                            </Link>
                            <Link to="#">
                              <img src={loginicon02} alt="#" />
                            </Link>
                            <Link to="#">
                              <img src={loginicon03} alt="#" />
                            </Link>
                          </div>
                          {/* /Social Login */}
                        </div>
                      </Spin>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Login Content */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
